import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";

// Assets
import EmptyState from "assets/empty-state-buyer-match.png";
import IEmptyArchived from "assets/empty-state-list-archived.png";

// Components
import ModalLoader from "components/organism/ModalLoader";
import Button from "components/v1/Button";
import ModalDetailMarketing from "./modal-detail-marketing";

const widthContainer = 1139;

const Size = {
  marketing: 355,
  listingAmount: 291,
  activityAmount: 291,
  aksi: 100,
};

// Class
const headerRowClassName =
  "flex items-center px-4 py-2 gap-[24px] bg-[#FaFaFa] border-b-[1px] border-solid border-[#D8D8D9]";
const headerColClassName =
  "text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#808285]";

const bodyRowClassName =
  "flex items-center px-4 py-[10px] gap-[24px] border-b-[0.5px] border-solid border-[#D8D8D9]";
const bodyColClassName =
  "text-[13px] leading-[21px] tracking-[-0.4px] font-inter truncate";

const MarketingTable = ({
  data,
  isLoading,
  isSearch,
}) => {
  const [selectedMarketing, setSelectedMarketing] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (marketing) => {
    setSelectedMarketing(marketing);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedMarketing(null);
  };
  const { pathname } = useLocation();
  const isArchived = pathname.includes("list-archived");

  const _getSize = (size) => {
    return `${(size / widthContainer) * 100}%`;
  };

  const renderMessage = useMemo(() => {
    let msg = {
      title: "",
      subtitle: "",
    };

    // List buyer search
    if (isSearch) {
      msg.title = "Customer Tidak Ditemukan";
      msg.subtitle =
        "Periksa kembali ejaan nama atau buat profil customer baru jika belum terdaftar.";

      return msg;
    }

    // List buyer
    if (!isSearch && !isArchived) {
      msg.title = "Belum ada profil customer";
      msg.subtitle =
        "Tambahkan profil customer untuk mulai menyesuaikan listing sesuai preferensi mereka.";

      return msg;
    }

    // List buyer archived
    if (!isSearch && isArchived) {
      msg.title = "Tidak Ada Arsip";
      msg.subtitle =
        "Belum ada customer yang Anda arsipkan. Customer yang diarsipkan akan ditampilkan di sini.";

      return msg;
    }

    return msg;
  }, [isSearch, isArchived]);

  return (
    <>
      <div className="rounded-[4px] border-[0.5px] border-solid border-[#D8D8D9] min-w-[1149px]">
        {/* Header */}
        <div className={headerRowClassName}>
          <div style={{ width: _getSize(Size.marketing) }}>
            <span className={headerColClassName}>Marketing</span>
          </div>
          <div style={{ width: _getSize(Size.listingAmount) }}>
            <span className={headerColClassName}>Jumlah Listing</span>
          </div>
          <div style={{ width: _getSize(Size.activityAmount) }}>
            <span className={headerColClassName}>Jumlah Showing Activity</span>
          </div>
          <div style={{ width: _getSize(Size.aksi) }}></div>
        </div>

        {/* Body */}
        {!!data?.length ? (
          data.map((item, index) => (
            <div key={`table-buyer-${index}`} className={bodyRowClassName}>
              <div style={{ width: _getSize(Size.marketing) }} className="flex items-center gap-6">
                <img src={item?.user?.image} alt={item?.user?.full_name} className="w-[40px] h-[40px] object-cover rounded-full" />
                <span className={bodyColClassName}>{item?.user?.full_name}</span>
              </div>
              <div style={{ width: _getSize(Size.listingAmount) }}>
                <span className={bodyColClassName}>{item?.total_listing || 0}</span>
              </div>
              <div style={{ width: _getSize(Size.activityAmount) }}>
                <span className={bodyColClassName}>{item?.total_showing_activity || 0}</span>
              </div>
              <div style={{ width: _getSize(Size.aksi) }} className="flex justify-end">
                <Button 
                  text="Lihat Detail"
                  type="secondary"
                  size="xs"
                  className="!py-0 h-[24px] !px-2 !font-inter !text-[11px]"
                  onClick={() => handleOpenModal(item)}
                />
              </div>
            </div>
          ))
        ) : !data?.length && !isLoading ? (
          <div className="h-[494px] flex flex-col items-center justify-center gap-0.5 py-6">
            <img
              className="w-[48px] h-[48px] object-contain"
              src={isArchived ? IEmptyArchived : EmptyState}
              alt="empty-state"
            />
            <p className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter-semibold text-[#252526]">
              {renderMessage.title}
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] font-inter text-[#808285]">
              {renderMessage.subtitle}
            </p>
          </div>
        ) : null}
      </div>

      <ModalLoader open={isLoading} />
      <ModalDetailMarketing isOpen={isModalOpen} marketing={selectedMarketing} onClose={handleCloseModal} />
    </>
  );
};

export default MarketingTable;
